import { Card, Table } from 'antd';
import React from 'react';

const DashboardTableSuppliers = ({ t, dataSuppliers }) => {
  const columns = [
    {
      title: t.suppliersName,
      dataIndex: 'supplier_name',
      key: 'supplier_name',
    },

    {
      title: t.CountPo,
      dataIndex: 'total_sales_order_count',
      key: 'total_sales_order_count',
    },
    {
      title: t.grandTotal,
      dataIndex: 'grand_total',
      key: 'grand_total',
      render: (text) => (
        <div className="flex items-center gap-1">
          {text}
          <span className="text-[10px] font-[400] text-[#878a99]">{t.SAR}</span>
        </div>
      ),
    },
  ];
  return (
    <>
      <Card
        style={{ height: '100%' }}
        styles={{
          body: {
            height: '100%',
          },
        }}
        title={t.topSuppliers}
      >
        <Table
          className="table_custom"
          // showHeader={false}
          columns={columns}
          pagination={{
            hideOnSinglePage: true,
          }}
          dataSource={dataSuppliers?.map((item) => ({ ...item, key: item.id }))}
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </>
  );
};

export default DashboardTableSuppliers;
